export enum SurveyMode {
  Introduction = 'introduction',
  Respond = 'respond',
  Confirmation = 'confirmation',
  Expired = 'expired'
}
